const MSG91_TOKEN = "430644T3xbRKBE95gN68a2d960P1";
const MSG91_WIDGET_ID = "35697070617a383933303336";

interface SendOtpPayload {
  identifier: string;
  tokenAuth?: string;
  widgetId?: string;
}

interface VerifyOtpPayload {
  otp: string;
  reqId: string;
  tokenAuth?: string;
  widgetId?: string;
}

interface RetryOtpPayload {
  reqId: string;
  retryChannel: string; // e.g., "11"
  tokenAuth?: string;
  widgetId?: string;
}

export const sendOtp = async (identifier: string) => {
  try {
    const res = await fetch("https://control.msg91.com/api/v5/widget/sendOtp", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        identifier,
        tokenAuth: MSG91_TOKEN,
        widgetId: MSG91_WIDGET_ID,
      }),
    });
    return await res.json();
  } catch (err) {
    throw new Error("Network error while sending OTP");
  }
};

export const verifyOtp = async (otp: string, reqId: string) => {
  try {
    const res = await fetch("https://control.msg91.com/api/v5/widget/verifyOtp", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        otp,
        reqId,
        tokenAuth: MSG91_TOKEN,
        widgetId: MSG91_WIDGET_ID,
      }),
    });
    return await res.json();
  } catch (err) {
    throw new Error("Network error while verifying OTP");
  }
};

export const retryOtp = async (reqId: string, retryChannel = "11") => {
  try {
    const res = await fetch("https://control.msg91.com/api/v5/widget/retryOtp", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        reqId,
        retryChannel,
        tokenAuth: MSG91_TOKEN,
        widgetId: MSG91_WIDGET_ID,
      }),
    });
    return await res.json();
  } catch (err) {
    throw new Error("Network error while retrying OTP");
  }
};
